export type TPageView = 'black' | 'white';
export const ERROR_TYPES = {
  BAD_REQUEST: '400',
  NOT_FOUND: '404',
  SERVER_ERROR: '500',
  UNKNOWN: 'unknown',
} as const;
export type TErrorTypes = keyof typeof ERROR_TYPES;
export type TErrorType = typeof ERROR_TYPES[TErrorTypes];
export interface IErrorContent {
  title: string;
  header: string;
  description: string;
  link?: string;
  linkText?: string;
}
